import React, { useRef, useState } from "react";
import InputField from "../../../common/components/FormFields/InputField";
import { useForm } from "react-hook-form";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CustomCreateable from "../EmrLite/CustomCreateable";
import { IconButton, Tooltip } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  getAdviceData,
  getCommonRoutes,
  getComplaintsData,
  getDiagnosis,
  getDrugForm,
  getGeneralFrequencies,
  getGenericDrugs,
  getInvestigations,
  getMedicationInstructions,
  getMedicines,
  getOtherServices,
} from "../EmrLite/Services";
import { EditIcon } from "../../../assets/CommonAssets";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TemplateMedicinesTable from "./TemplateMedicinesTable";
import { CapitalizeStatement } from "../../../common/components/Custom Hooks/CapitalizeStatement";
import {
  emrTemplateEditData,
  getAdviceDropDownData,
  saveEMRTemplate,
  updateEMRTemplate,
} from "../../services/emrTemplateServices/EMRTemplateServices";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { doctorDropdown } from "../../services/patientappointmentservices/PatientVisitListServices";

const medicinesData = [
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
  {
    Medicine: "",
    Dosage: "",
    Frequency: "",
    Route: "",
    Duration: "",
    Quantity: "",
    Instructions: "",
    Generic: "",
    Form: "",
    since: "",
    isDeleted: false,
  },
];
function NewEmrTemplate({
  editRow,
  setSelectedTab,
  setSelectedRow,
  populateTable,
  getDoctorId,
}) {
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
  let token = JSON.parse(localStorage.getItem("userInfo"));
  const complaintRef = useRef(null);

  const location = useLocation();
  const [formData, setFormData] = useState([]);
  const [complaintsOptions, setComplaintsOptions] = useState([]);
  const [selectedComplaints, setSelectedComplaints] = useState([]);
  const [editComplaintIndex, setEditComplaintIndex] = useState(null);
  const [resetComplaints, setResetComplaints] = React.useState(0);
  const [medicineInstructions, setMedicineInstructions] = React.useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState([]);
  const [diagnoOptions, setDiagnoOptions] = useState([]);
  const [invOptions, setInvOptions] = useState([]);
  const [selectedInvestigations, setSelectedInvestigations] = useState([]);
  const [resetInv, setResetInv] = useState(0);
  const [selectedMedicines, setSelectedMedicines] = useState([
    ...medicinesData,
  ]);
  const [searchMedicines, setSearchMedicines] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [genericDrugs, setGenericDrugs] = useState([]);
  const [formOpt, setFormOpt] = useState([]);
  const [advicesOptions, setAdvicesOptions] = useState([]);
  const [selectedAdvices, setSelectedAdvices] = useState([]);
  const [selectedOtherReferral, setSelectedOtherReferral] = useState([]);
  const [servicesOptions, setServicesOptions] = useState([]);
  const [otherServices, setOtherServices] = useState([]);
  const [resetServices, setResetServices] = useState(0);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [doctor, setDoctor] = useState();

  const schema = yup
    .object()
    .shape({
      templateName: yup.string().trim().required("Template Name is Required"),
      medicine: yup.array().of(
        yup.object().shape({
          Dosage: yup.string().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) => schema.required("Dosage is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Frequency: yup.mixed().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) =>
              schema
                .test((val) => typeof val === "object")
                .required("Frequency is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Route: yup.mixed().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) =>
              schema
                .test((val) => typeof val === "object")
                .required("Route is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Duration: yup.string().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) => schema.required("Duration is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Quantity: yup.string().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) => schema.required("Quantity is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Instructions: yup.mixed().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) =>
              schema
                .test((val) => typeof val === "object")
                .required("Instructions are required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Generic: yup.mixed().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) =>
              schema
                .test((val) => typeof val === "object")
                .required("Generic is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          Form: yup.mixed().when("Medicine", {
            is: (val) => val !== null && val !== "",
            then: (schema) =>
              schema
                .test((val) => typeof val === "object")
                .required("Form is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          since: yup.string().nullable(),
          isDeleted: yup.boolean(),
        })
      ),
    })
    .required();

  const defaultValues = {
    templateName: "",
    description: "",
    searchDiagnosis: null,
    referralDoctor: null,
    nextFollowupDate: new Date(),
    searchOtherServices: null,
  };
  const {
    control,
    formState: { errors },
    watch,
    register,
    setValue,
    clearErrors,
    reset,
    handleSubmit,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  let complaintWatch = watch("searchComplaint");
  let investigationWatch = watch("searchInvestigations");
  let diagnosisWatch = watch("searchDiagnosis");
  let otherReferralWatch = watch("referralDoctor");
  let advicesWatch = watch("searchAdvices");
  let watchOtherServices = watch("searchOtherServices");
  const getDoctor = watch("doctor");

  React.useEffect(() => {
    getGeneralFrequencies(0)
      .then((response) => response.data)
      .then((res) => {
        setFrequencyOptions(res?.result);
      })
      .catch((error) => error);

    getCommonRoutes()
      .then((response) => response.data)
      .then((res) => {
        setRoutes(res?.result);
      })
      .catch((err) => err);

    getDrugForm()
      .then((response) => response.data)
      .then((res) => {
        setFormOpt(res.result);
      })
      .catch((err) => err);

    getAdviceDropDownData()
      .then((response) => response.data)
      .then((res) => {
        setAdvicesOptions(res?.result);
      })
      .catch((err) => err);
  }, []);

  React.useEffect(() => {
    getMedicationInstructions()
      .then((response) => response.data)
      .then((res) => {
        setMedicineInstructions(res.result);
      })
      .catch((err) => err);
  }, []);

  const getDoctorDropdownList = (searchDoctorString) => {
    if (searchDoctorString !== "") {
      doctorDropdown(searchDoctorString)
        .then((response) => response.data)
        .then((res) => {
          if (searchDoctorString !== null) {
            setDoctor(res.result);
          }
        });
    }
  };

  const handleSearchComplaints = (search) => {
    if (search !== "") {
      getComplaintsData(search)
        .then((response) => response.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setComplaintsOptions(res?.result);
          }
        })
        .catch((er) => er);
    }
  };

  const handleEditComplaint = (complaintObject, complaintIndex) => {
    let patchComplaint = {
      id: complaintObject?.value,
      label: complaintObject?.label,
      value: complaintObject?.value,
    };
    setValue("searchComplaint", patchComplaint);
    setEditComplaintIndex(complaintIndex);
  };

  const handleUpdateComplaint = () => {
    let newComplaint = {
      id: complaintWatch?.__isNew__ === true ? null : complaintWatch.id,
      label: complaintWatch.label,
      value: complaintWatch.value || null,
      since: "",
      duration: "D",
      isChecked: true,
    };
    let dataArray = [...selectedComplaints];
    let filtered = dataArray.filter(
      (complaint) => complaint?.label === complaintWatch?.label
    );
    if (filtered?.length === 0) {
      dataArray.splice(editComplaintIndex, 1, newComplaint);
      setSelectedComplaints(dataArray);
      setValue("searchComplaint", null);
      setEditComplaintIndex(null);
    } else {
      errorAlert("Complaint already exists.");
      setEditComplaintIndex(null);
      setValue("searchComplaint", null);
    }
  };

  const handleDeleteComplaints = (complaint) => {
    let dataArray = [...selectedComplaints];
    let filtered = dataArray.filter((item) => item !== complaint);
    setSelectedComplaints(filtered);
  };

  //diagnosis

  const handelSearchDiagnosis = (search) => {
    if (search !== "") {
      getDiagnosis(
        search,
        loggedUser?.loginUnitId,
        location?.state?.departmentId
      )
        .then((response) => response.data)
        .then((res) => {
          setDiagnoOptions(res?.result);
        })
        .catch((er) => er);
    }
  };

  const handleDeleteDiagnosis = (diagno) => {
    let dataArray = [...selectedDiagnosis];
    let filtered = dataArray.filter((item) => item !== diagno);
    setSelectedDiagnosis(filtered);
  };

  //Investigation

  const handleSearchInvestigations = (search) => {
    if (search !== "") {
      getInvestigations(search, 2)
        .then((response) => response.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setInvOptions(res?.result);
          }
        })
        .catch((er) => er);
    }
  };

  const handleDeleteInv = (inv) => {
    let dataArray = [...selectedInvestigations];
    let filtered = dataArray.filter((item) => item !== inv);
    setSelectedInvestigations(filtered);
    setResetInv(resetInv + 1);
  };

  //medication

  const handleGetMedicine = (search) => {
    if (search !== "" && UseCheckConsecutiveCharacters(search)) {
      getMedicines(search)
        .then((response) => {
          setSearchMedicines(response.data.result);
        })
        .catch((error) => error);
    } else {
      setSearchMedicines([]);
    }
  };

  const handleGetGenerics = (searchGenericName) => {
    if (
      searchGenericName &&
      searchGenericName !== undefined &&
      UseCheckConsecutiveCharacters(searchGenericName)
    ) {
      getGenericDrugs(searchGenericName)
        .then((response) => response.data)
        .then((res) => {
          setGenericDrugs(res.result);
        });
    }
  };

  const handleAllDurations = (isApply) => {
    let dataArray = [...selectedMedicines];
    let firstMedicine = dataArray[0];
    if (isApply === true) {
      for (let medicine of dataArray) {
        if (
          firstMedicine?.Medicine !== null &&
          Number(firstMedicine?.since) > 0
        ) {
          if (
            medicine?.Medicine !== "" &&
            medicine?.Medicine?.id !== firstMedicine?.Medicine?.id
          ) {
            medicine.since = firstMedicine?.since;
          }
        }
      }
      setSelectedMedicines(dataArray);
    } else if (isApply === false) {
      for (let medicine of dataArray) {
        if (
          medicine?.Medicine !== "" &&
          medicine?.Medicine?.id !== firstMedicine?.Medicine?.id
        ) {
          medicine.since = "";
        }
      }
      setSelectedMedicines(dataArray);
    }
  };

  const renderInput = (row, index, header) => {
    if (row?.Medicine === "") {
      setValue(`medicine[${index}].Medicine`, null);
    } else {
      setValue(`medicine[${index}].Medicine`, row?.Medicine);
    }

    if (row?.Medicine === "") {
      setValue(`medicine[${index}].Generic`, null);
      setValue(`medicine[${index}].Form`, null);
    }

    if (row?.Dosage === "") {
      setValue(`medicine[${index}].Dosage`, "");
    } else {
      setValue(`medicine[${index}].Dosage`, row?.Dosage);
    }

    if (row?.Frequency?.label !== "") {
      setValue(`medicine[${index}].Frequency`, row?.Frequency);
    } else {
      setValue(`medicine[${index}].Frequency`, null);
    }

    setValue(`duration[${index}].since`, row?.since);

    if (row?.Route === "") {
      setValue(`medicine[${index}].Route`, null);
    } else {
      setValue(`medicine[${index}].Route`, row?.Route);
    }

    if (row?.Duration === "") {
      setValue(`medicine[${index}].Duration`, "");
      setValue(`medicine[${index}].Quantity`, "");
    } else {
      setValue(`medicine[${index}].Duration`, row?.Duration);
    }

    const calculateQuantity = (frequency, duration) => {
      if (!frequency || !duration) return 0;

      let frequencyCountValue = 0;
      let freqArray = frequency.label.split("-");

      freqArray.forEach((element) => {
        let value = element.trim();

        if (value === "1/2" || value === "½") {
          frequencyCountValue += 0.5;
        } else if (value === "¼") {
          frequencyCountValue += 0.25;
        } else if (value === "1") {
          frequencyCountValue += 1;
        } else if (value === "1½") {
          frequencyCountValue += 1.5;
        } else if (value === "1/8") {
          frequencyCountValue += 0.125;
        } else if (value === "2") {
          frequencyCountValue += 2;
        } else if (value === "2½") {
          frequencyCountValue += 2.5;
        } else if (value === "3") {
          frequencyCountValue += 3;
        } else if (value === "3½") {
          frequencyCountValue += 3.5;
        } else if (value === "4") {
          frequencyCountValue += 4;
        } else if (value === "4½") {
          frequencyCountValue += 4.5;
        } else if (value === "STAT") {
          frequencyCountValue += 1;
        } else if (value === "Stat/sos") {
          frequencyCountValue += 1;
        } else if (value === "SOS") {
          frequencyCountValue += 1;
        }
      });
      const quantityCount = Number(duration) * frequencyCountValue;
      return Math.ceil(quantityCount);
    };

    return (
      <div
        className={`flex justify-start z-50 ${
          index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
            ? "hidden"
            : ``
        } `}
      >
        {header === "Medicine" ? (
          <div className="flex justify-start w-[25vw] lg:w-full">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              menuPlacement={"bottom"}
              width={"250px"}
              control={control}
              name={`medicine[${index}].Medicine`}
              placeholder={"Medicine"}
              handleInputChange={handleGetMedicine}
              inputRef={{
                ...register(`medicine[${index}].Medicine`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    if (e.target.value !== null) {
                      let genericNameObj = {
                        id: e.target.value.genericId,
                        value: e.target.value.genericName,
                        label: e.target.value.genericName,
                      };

                      let formObj = {
                        id: e.target.value.formId,
                        value: e.target.value.form,
                        label: e.target.value.form,
                      };

                      let filtered = dataArray.filter(
                        (item) =>
                          item?.Medicine?.label === e.target.value?.label
                      );

                      if (filtered.length === 0) {
                        let newMedicine = {
                          id:
                            e.target.value?.__isNew__ === true
                              ? null
                              : e.target.value?.id,
                          label: e.target.value?.label,
                          value:
                            e.target.value?.__isNew__ === true
                              ? null
                              : e.target.value?.id,
                        };

                        dataArray[index] = {
                          ...dataArray[index],
                          Medicine: newMedicine,
                          Generic: e.target.value.genericId
                            ? genericNameObj
                            : null,
                          Form: e.target.value.formId ? formObj : null,
                        };

                        if (
                          e.target.value.genericId !== null &&
                          e.target.value.genericId !== undefined
                        ) {
                          setValue(
                            `medicine[${index}].Generic`,
                            genericNameObj
                          );
                          clearErrors([`medicine[${index}].Generic`]);
                        }
                        if (
                          e.target.value.formId !== null &&
                          e.target.value.formId !== undefined
                        ) {
                          setValue(`medicine[${index}].Form`, formObj);
                          clearErrors([`medicine[${index}].Form`]);
                        }
                        setSelectedMedicines(dataArray);
                        const nextField = document.querySelector(
                          `input[name="medicine[${index}].Dosage"]`
                        );
                        nextField?.focus();
                      } else {
                        setValue(`medicine[${index}].Medicine`, null);
                        errorAlert("Medicine / Drug already exists");
                      }
                    } else {
                      setValue(`medicine[${index}].Generic`, null);
                      setValue(`medicine[${index}].Form`, null);
                      dataArray[index] = {
                        ...dataArray[index],
                        Medicine: "",
                        Generic: null,
                        Form: null,
                      };
                      setSelectedMedicines(dataArray);
                    }
                  },
                }),
              }}
              dataArray={searchMedicines}
              isSearchable={true}
            />
          </div>
        ) : null}

        {header === "Dosage" ? (
          <div className="flex justify-start w-full ml-2">
            <input
              className={`h-7 w-32 border ${
                errors?.medicine?.[index]?.Dosage
                  ? "border-red-500"
                  : "border-gray-400"
              }  rounded px-2`}
              style={{ outline: "none" }}
              placeholder="Dosage"
              name={`medicine[${index}].Dosage`}
              {...register(`medicine[${index}].Dosage`)}
              onChange={(e) => {
                let dataArray = [...selectedMedicines];
                dataArray[index].Dosage = e.target.value;
                setSelectedMedicines(dataArray);
                clearErrors(`medicine[${index}].Dosage`);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const nextField = document
                    .querySelector(`[name="medicine[${index}].Frequency"]`)
                    ?.closest(".w-full");
                  if (nextField) {
                    const selectInput = nextField.querySelector("input");
                    if (selectInput) {
                      selectInput.focus();
                      const selectDiv = nextField.querySelector(
                        ".css-1s2u09g-control"
                      );
                      if (selectDiv) {
                        selectDiv.click();
                      }
                    }
                  }
                }
              }}
            />
          </div>
        ) : null}

        {header === "Frequency" ? (
          <div className="flex justify-start ml-2 w-[20vw] xl:w-full">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Frequency`}
              placeholder={"Frequency"}
              error={errors?.medicine?.[index]?.Frequency}
              handleInputChange={() => {}}
              isClearable={true}
              inputRef={{
                ...register(`medicine[${index}].Frequency`, {
                  onChange: (e) => {
                    if (
                      e.target.value !== null &&
                      e.target.value !== undefined
                    ) {
                      let dataArray = [...selectedMedicines];
                      dataArray[index].Frequency = e.target.value;

                      const duration = dataArray[index].Duration;
                      if (duration) {
                        const quantity = calculateQuantity(
                          e.target.value,
                          duration
                        );
                        setValue(`medicine[${index}].Quantity`, quantity);
                        dataArray[index].Quantity = quantity;
                      }

                      setSelectedMedicines(dataArray);
                      const nextField = document
                        .querySelector(`[name="medicine[${index}].Route"]`)
                        ?.closest(".w-full");

                      if (nextField) {
                        const routeInput = nextField.querySelector("input");
                        if (routeInput) {
                          routeInput.focus();
                        }
                      }
                    } else {
                      let dataArray = [...selectedMedicines];
                      dataArray[index].Frequency = "";
                      setValue(`medicine[${index}].Quantity`, 0);
                      dataArray[index].Quantity = 0;
                      setSelectedMedicines(dataArray);
                    }
                  },
                }),
              }}
              dataArray={frequencyOptions}
              isSearchable={true}
            />
          </div>
        ) : null}

        {header === "Route" ? (
          <div className="flex justify-start w-[17vw] xl:w-full ml-2">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Route`}
              error={errors?.medicine?.[index]?.Route}
              placeholder={"Route"}
              handleInputChange={() => {}}
              inputRef={{
                ...register(`medicine[${index}].Route`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Route = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document.querySelector(
                      `input[name="medicine[${index}].Duration"]`
                    );
                    nextField?.focus();
                  },
                }),
              }}
              dataArray={routes}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}

        {header === "Duration" ? (
          <div className="flex gap-2 items-center ml-2">
            <input
              disabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              name={`medicine[${index}].Duration`}
              {...register(`medicine[${index}].Duration`)}
              style={{ outline: "none" }}
              placeholder="Duration"
              className={`h-7 w-32 border ${
                errors?.medicine?.[index]?.Duration
                  ? "border-red-500"
                  : "border-gray-400"
              }  rounded px-2`}
              onChange={(e) => {
                let dataArray = [...selectedMedicines];
                dataArray[index].Duration = e.target.value;
                const frequency = dataArray[index].Frequency;
                if (frequency) {
                  const quantity = calculateQuantity(frequency, e.target.value);
                  setValue(`medicine[${index}].Quantity`, quantity);
                  dataArray[index].Quantity = quantity;
                  clearErrors(`medicine[${index}].Quantity`);
                }
                clearErrors(`medicine[${index}].Duration`);
                setSelectedMedicines(dataArray);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const nextField = document
                    .querySelector(`[name="medicine[${index}].Instructions"]`)
                    ?.closest(".w-full");
                  if (nextField) {
                    const selectInput = nextField.querySelector("input");
                    if (selectInput) {
                      selectInput.focus();
                      const selectDiv = nextField.querySelector(
                        ".css-1s2u09g-control"
                      );
                      if (selectDiv) {
                        selectDiv.click();
                      }
                    }
                  }
                }
              }}
            />
            <div className="px-3 rounded-full bg-[#073763] text-sm py-0.5 text-white">
              Days
            </div>
          </div>
        ) : null}

        {header === "Quantity" ? (
          <div className="flex justify-start w-full ml-2">
            <input
              className={`h-7 w-32 border ${
                errors?.medicine?.[index]?.Quantity
                  ? "border-red-500"
                  : "border-gray-400"
              }  rounded px-2`}
              style={{ outline: "none" }}
              placeholder="Qty"
              name={`medicine[${index}].Quantity`}
              {...register(`medicine[${index}].Quantity`)}
              disabled={true}
            />
          </div>
        ) : null}

        {header === "Instructions" ? (
          <div className="flex justify-start ml-2 w-[20vw] xl:w-full">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              control={control}
              name={`medicine[${index}].Instructions`}
              error={errors?.medicine?.[index]?.Instructions}
              placeholder={"Instructions"}
              handleInputChange={() => {}}
              inputRef={{
                ...register(`medicine[${index}].Instructions`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Instructions = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document
                      .querySelector(`[name="medicine[${index}].Generic"]`)
                      ?.closest(".w-full");

                    if (nextField) {
                      const routeInput = nextField.querySelector("input");
                      if (routeInput) {
                        routeInput.focus();
                      }
                    }
                  },
                }),
              }}
              dataArray={medicineInstructions}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}

        {header === "Generic" ? (
          <div className="flex justify-start pl-2 w-[20vw] xl:w-full">
            <CustomCreateable
              control={control}
              name={`medicine[${index}].Generic`}
              isSearchable={true}
              placeholder={"Generic"}
              error={errors?.medicine?.[index]?.Generic}
              isClearable={true}
              handleInputChange={handleGetGenerics}
              inputRef={{
                ...register(`medicine[${index}].Generic`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Generic = e.target.value;
                    setSelectedMedicines(dataArray);
                    const nextField = document
                      .querySelector(`[name="medicine[${index}].Form"]`)
                      ?.closest(".w-full");

                    if (nextField) {
                      const routeInput = nextField.querySelector("input");
                      if (routeInput) {
                        routeInput.focus();
                      }
                    }
                  },
                }),
              }}
              dataArray={genericDrugs}
            />
          </div>
        ) : null}

        {header === "Form" ? (
          <div className="flex justify-start w-[18vw] xl:w-full ml-2">
            <CustomCreateable
              isDisabled={
                index !== 0 && selectedMedicines[index - 1]?.Medicine === ""
                  ? true
                  : false
              }
              width={"170px"}
              control={control}
              name={`medicine[${index}].Form`}
              placeholder={"Form"}
              handleInputChange={() => {}}
              error={errors?.medicine?.[index]?.Form}
              inputRef={{
                ...register(`medicine[${index}].Form`, {
                  onChange: (e) => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].Form = e.target.value;
                    setSelectedMedicines(dataArray);
                  },
                }),
              }}
              dataArray={formOpt}
              isSearchable={true}
              isClearable={true}
            />
          </div>
        ) : null}
      </div>
    );
  };

  const renderActions = (row, index) => {
    return (
      <div className="flex items-center">
        <>
          {row?.Medicine !== "" ? (
            <div className="flex gap-2 cursor-pointer">
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    let dataArray = [...selectedMedicines];
                    dataArray[index].isDeleted = true;
                    setSelectedMedicines(dataArray);
                  }}
                  sx={{ padding: 0, margin: 0 }}
                >
                  <DeleteOutlineIcon fontSize="small" sx={{ color: "red" }} />
                </IconButton>
              </Tooltip>
            </div>
          ) : null}
        </>
      </div>
    );
  };

  const handleDeleteAdvice = (advice) => {
    let dataArray = [...selectedAdvices];
    let filtered = dataArray.filter((item) => item.value !== advice.value);
    setSelectedAdvices(filtered);
  };

  const handleSearchServices = (search) => {
    if (search !== "") {
      getOtherServices(search)
        .then((response) => response.data)
        .then((res) => {
          setServicesOptions(res?.result);
        })
        .catch((err) => err);
    }
  };

  const handleDeleteOtherService = (row) => {
    let dataArray = [...otherServices];
    let filtered = dataArray.filter((item) => item !== row);
    setOtherServices(filtered);
    setResetServices(resetServices + 1);
  };

  const onSubmit = (data) => {
    let complaints = [];
    for (let complaint of selectedComplaints) {
      let complaintObj = {
        // complaintId: complaint?.id,
        // complaint: complaint?.label,
        complaint:
          complaint.id !== null
            ? { id: complaint.id }
            : { description: complaint.label },
      };
      complaints.push(complaintObj);
    }

    let diagnosis = [];
    for (let diagno of selectedDiagnosis) {
      let diagnoObj = {
        // diagnosisId: diagno?.id,
        // diagnosis: diagno?.label,
        diagnosis:
          diagno.id !== null ? { id: diagno.id } : { diagnosis: diagno.label },
      };
      diagnosis.push(diagnoObj);
    }

    // let investigation = [];
    // for (let inv of selectedInvestigations) {
    //   let invObj = {
    //     serviceId: inv?.testId ? inv?.testId : null,
    //     serviceName: inv?.label,
    //   };
    //   investigation.push(invObj);
    // }

    let services = [];
    let servicesDataArray = [...selectedInvestigations, ...otherServices];
    for (let serTemp of servicesDataArray) {
      let serviceObj = {
        service: { id: serTemp.id },
      };
      services.push(serviceObj);
    }

    let medications = [];
    let filteredMedicines = selectedMedicines.filter(
      (medicine) => medicine?.Medicine !== ""
    );

    if (filteredMedicines.length > 0) {
      for (let object of filteredMedicines) {
        if (!object.isDeleted) {
          let medicationObj = {
            id: object?.id ? object.id : null,
            itemId: object?.Medicine.id ? object?.Medicine.id : null,
            itemName: object?.Medicine?.label,
            dosage: object?.Dosage,
            duration:
              Number(object?.Duration) > 0 ? Number(object.Duration) : null,
            durationIn: "Days",
            formId: object.Form.id ? object.Form.id : null,
            formName: object.Form?.label,
            frequencyName: object?.Frequency?.label,
            frequencyId: object?.Frequency?.id,
            genericId: object?.Generic?.id,
            genericName: object?.Generic?.label,
            instructionName: object?.Instructions?.label,
            instructionId: object?.Instructions?.Id,
            quantity: object?.Quantity,
            routeId: object?.Route.Id,
            routeName: object?.Route?.label,
            // isDelete: object?.isDeleted,
          };
          medications.push(medicationObj);
        }
      }
    }

    let advices = [];
    if (selectedAdvices.length > 0) {
      for (let adv of selectedAdvices) {
        let advObj = {
          advice: adv.id !== null ? { id: adv.id } : { advice: adv.label },
        };
        advices.push(advObj);
      }
    }

    // let otherService = [];
    // for (let othService of otherServices) {
    //   let otherServiceObj = {
    //     serviceId: othService?.id,
    //     serviceName: othService?.label,
    //   };
    //   otherService.push(otherServiceObj);
    // }

    const formObj = {
      id: editRow,
      doctorId: token.doctorId !== null ? token?.doctorId : getDoctor.id,
      templateName: data?.templateName,
      description: data?.description,
      complaints: complaints,
      diagnosis: diagnosis,
      // investigation: investigation,
      services: services,
      items: medications,
      advices: advices,
      // otherServices: otherService,
    };

    setFormData(formObj);
    setOpenConfirmationModal(true);
  };

  // saveEMRTemplate

  const handleOnSubmit = () => {
    if (editRow === null) {
      saveEMRTemplate(formData)
        .then((response) => response.data)
        .then((res) => {
          successAlert(res?.message);
          setOpenConfirmationModal(false);
          populateTable();
          setSelectedRow(null);
          setSelectedTab(0);
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    } else {
      updateEMRTemplate(formData)
        .then((response) => response.data)
        .then((res) => {
          successAlert(res?.message);
          setOpenConfirmationModal(false);
          populateTable();
          setSelectedRow(null);
          setSelectedTab(0);
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    }
  };

  function findNextComplaint() {
    var universe = document.querySelectorAll("input");

    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });

    let filtered = list.filter(
      (field) => field.id === "react-select-4-input" && field.name === ""
    );

    return filtered[0]?.focus();
  }

  function findNextDiagnosis() {
    var universe = document.querySelectorAll("input");
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });

    let filtered = list.filter(
      (field) => field.id === "react-select-5-input" && field.name === ""
    );

    return filtered[0]?.focus();
  }

  function findNextInvestigation() {
    var universe = document.querySelectorAll("input");
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });

    let filtered = list.filter(
      (field) => field.id === "react-select-6-input" && field.name === ""
    );

    return filtered[0]?.focus();
  }

  function findNextOtherServices() {
    var universe = document.querySelectorAll("input");
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });

    let filtered = list.filter(
      (field) => field.id === "react-select-140-input" && field.name === ""
    );

    return filtered[0]?.focus();
  }

  React.useEffect(() => {
    if (complaintWatch !== null && complaintWatch !== undefined) {
      findNextComplaint();
    }

    let filterdComplaints = selectedComplaints.filter(
      (list) => list.label === complaintWatch?.label
    );

    if (editComplaintIndex === null) {
      if (
        complaintWatch !== null &&
        complaintWatch !== undefined &&
        filterdComplaints?.length > 0
      ) {
        errorAlert("Complaint Already Exist..!");
        setValue("searchComplaint", null);
      } else {
        if (complaintWatch !== null && complaintWatch !== undefined) {
          let combinedComplaints = [...selectedComplaints];

          if (complaintWatch && complaintWatch.label) {
            combinedComplaints.push({
              id: complaintWatch?.__isNew__ === true ? null : complaintWatch.id,
              label: complaintWatch.label,
              value: complaintWatch.value || null,
              since: "",
              duration: "D",
              isChecked: true,
            });
          }

          combinedComplaints = combinedComplaints.filter(
            (item) => item.label && item.isChecked
          );

          const uniqueArray = Array.from(
            new Map(
              combinedComplaints.map((item) => [item.label, item])
            ).values()
          ).sort((a, b) => {
            if (a.value === null) return 1;
            if (b.value === null) return -1;
            return a.value - b.value;
          });

          setSelectedComplaints(uniqueArray);
          setValue("searchComplaint", null);
        } else {
          let dataArray = [...selectedComplaints];
          for (let object of dataArray) {
            if (object?.label === complaintWatch?.label) {
              object.isChecked = true;
            }

            setValue("searchComplaint", null);
          }
        }

        setResetComplaints(resetComplaints + 1);
      }
    }
  }, [complaintWatch]);

  React.useEffect(() => {
    if (diagnosisWatch !== null && diagnosisWatch !== undefined) {
      findNextDiagnosis();
    }

    let filterdDiagnosis = selectedDiagnosis.filter(
      (list) => list.label === diagnosisWatch?.label
    );

    if (editComplaintIndex === null) {
      if (
        diagnosisWatch !== null &&
        diagnosisWatch !== undefined &&
        filterdDiagnosis?.length > 0
      ) {
        errorAlert("Diagnosis Already Exist..!");
        setValue("searchDiagnosis", null);
      } else {
        if (diagnosisWatch !== null && diagnosisWatch !== undefined) {
          let combinedDiagnosis = [...selectedDiagnosis];

          if (diagnosisWatch && diagnosisWatch.label) {
            combinedDiagnosis.push({
              id: diagnosisWatch?.__isNew__ === true ? null : diagnosisWatch.id,
              label: diagnosisWatch.label,
              value: diagnosisWatch.value || null,
              since: "",
              duration: "D",
              isChecked: true,
            });
          }

          combinedDiagnosis = combinedDiagnosis.filter(
            (item) => item.label && item.isChecked
          );

          const uniqueArray = Array.from(
            new Map(
              combinedDiagnosis.map((item) => [item.label, item])
            ).values()
          ).sort((a, b) => {
            if (a.value === null) return 1;
            if (b.value === null) return -1;
            return a.value - b.value;
          });

          setSelectedDiagnosis(uniqueArray);
          setValue("searchDiagnosis", null);
        } else {
          let dataArray = [...selectedComplaints];
          for (let object of dataArray) {
            if (object?.label === diagnosisWatch?.label) {
              object.isChecked = true;
            }
            setValue("searchDiagnosis", null);
          }
        }
      }
    }
  }, [diagnosisWatch]);

  // React.useEffect(() => {
  //   if (diagnosisWatch !== null && diagnosisWatch !== undefined) {
  //     findNextDiagnosis();
  //   }
  //   if (diagnosisWatch) {
  //     let dataArray = [...selectedDiagnosis];
  //     let diagno = diagnosisWatch;

  //     const filterdDiagnosis = dataArray.filter(
  //       (list) => list.value === diagno.value
  //     );

  //     if (filterdDiagnosis.length > 0) {
  //       errorAlert("Diagnosis Already Exist!");
  //     } else {
  //       diagno.isChecked = true;
  //       dataArray.push(diagno);

  //       const combinedComplaints = dataArray.filter(
  //         (item) => item.label && item.isChecked
  //       );

  //       const uniqueDiagnosis = Array.from(
  //         new Map(combinedComplaints.map((item) => [item.label, item])).values()
  //       ).sort((a, b) => {
  //         if (a.value === null) return 1;
  //         if (b.value === null) return -1;
  //         return a.value - b.value;
  //       });

  //       setSelectedDiagnosis(uniqueDiagnosis);

  //       const previousDiagnosis = [...diagnosis];
  //       const mergedDiagnosis = [
  //         ...new Map(
  //           [...previousDiagnosis, ...combinedComplaints].map((item) => [
  //             item.label,
  //             item,
  //           ])
  //         ).values(),
  //       ];

  //
  //     }

  //     setValue("searchDiagnosis", null);
  //   }
  // }, [diagnosisWatch, selectedDiagnosis]);

  React.useEffect(() => {
    if (investigationWatch?.label !== "") {
      findNextInvestigation();
    }
    let dataArray = [...selectedInvestigations];
    let filtered = dataArray.filter(
      (inv) => inv.label === investigationWatch?.label
    );
    if (filtered.length > 0 && investigationWatch !== null) {
      errorAlert("Investigation Already Exist");
      setValue("searchInvestigations", null);
    } else if (investigationWatch?.label !== undefined) {
      let investigationObject = {
        id: investigationWatch?.ServiceId,
        label: investigationWatch?.label,
        value: investigationWatch?.value,
      };

      dataArray.push(investigationObject);

      let tempArr = selectedInvestigations.filter(
        (list) => list.testId !== undefined && list.serviceId !== undefined
      );

      setValue("searchInvestigations", null);
      setSelectedInvestigations(dataArray);
    }
  }, [investigationWatch]);

  function findNextAdvices() {
    var universe = document.querySelectorAll("input");
    var list = Array.prototype.filter.call(universe, function (item) {
      return item.tabIndex >= "0";
    });

    let filtered = list.filter(
      (field) => field.id === "react-select-139-input" && field.name === ""
    );

    return filtered[0]?.focus();
  }

  React.useEffect(() => {
    if (advicesWatch !== null && advicesWatch !== undefined) {
      findNextAdvices();
    }
    if (advicesWatch) {
      let dataArray = [...selectedAdvices];
      let advices = advicesWatch;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === advices.value
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Advice Already Exist!");
        setValue("searchAdvices", null);
      } else if (advicesWatch !== undefined) {
        let otherReferralObject = {
          id: advicesWatch?.__isNew__ === true ? null : advicesWatch.id,
          label: advicesWatch.label,
          value: advicesWatch.value,
        };

        dataArray.push(otherReferralObject);
        setValue("searchAdvices", null);
        setSelectedAdvices(dataArray);
      }
    }
  }, [advicesWatch]);

  React.useEffect(() => {
    if (watchOtherServices !== null && watchOtherServices !== undefined) {
      findNextOtherServices();
    }
    if (watchOtherServices) {
      let dataArray = [...otherServices];
      let otherService = watchOtherServices;

      const filteredAllergy = dataArray.filter(
        (list) => list.value === otherService.value
      );

      if (filteredAllergy.length > 0) {
        errorAlert("Service Already Exist!");
        setValue("searchOtherServices", null);
      } else if (watchOtherServices !== undefined) {
        let otherServicesObj = {
          id: watchOtherServices.id,
          label: watchOtherServices.label,
          value: watchOtherServices.value,
        };

        dataArray.push(otherServicesObj);
        setValue("searchOtherServices", null);
        setOtherServices(dataArray);
      }
    }
  }, [watchOtherServices]);

  React.useEffect(() => {
    if (editRow !== null) {
      emrTemplateEditData(editRow)
        .then((response) => response.data)
        .then((res) => {
          let dataArray = res?.result[0];

          setValue("templateName", dataArray?.templateName);
          setValue("description", dataArray?.description);
          setValue("doctor", getDoctorId);

          let complaints = JSON.parse(dataArray?.emrComplaints || "[]");

          let editComplaints = [];
          if (complaints.length > 0) {
            for (let comp of complaints) {
              let complaintObj = {
                id: comp?.id,
                label: comp?.description,
                value: comp?.description,
                since: "",
                duration: "D",
                isChecked: true,
              };
              editComplaints.push(complaintObj);
              setSelectedComplaints(editComplaints);
            }
          }

          let diagnosis = JSON.parse(dataArray?.emrDiagnosis || "[]");

          let editDiagnosis = [];
          if (diagnosis.length > 0) {
            for (let diagno of diagnosis) {
              let diagnosisObj = {
                id: diagno?.id,
                label: diagno?.diagnosis,
                since: "",
                duration: "D",
                isChecked: true,
              };
              editDiagnosis.push(diagnosisObj);
              setSelectedDiagnosis(editDiagnosis);
            }
          }

          // let investigations = JSON.parse();
          // let editInvestigation = [];
          // if (investigations.length > 0) {
          //   for (let inv of investigations) {
          //     let invObj = {
          //       label: inv?.serviceName,
          //       id: inv?.serviceId,
          //       value: inv?.serviceId,
          //     };
          //     editInvestigation.push(invObj);
          //     setSelectedInvestigations(editInvestigation);
          //   }
          // }

          let services = JSON.parse(dataArray?.emrServices || "[]");
          let selectedInvestigations = [];
          let otherServices = [];

          if (services.length > 0) {
            for (let serv of services) {
              let serviceObj = {
                id: serv?.id,
                label: serv?.Label,
                value: serv?.Label,
                groupId: serv?.GroupId,
              };

              if (serviceObj.groupId === 2 || serviceObj.groupId === 32) {
                selectedInvestigations.push(serviceObj);
              } else {
                otherServices.push(serviceObj);
              }
            }

            setSelectedInvestigations(selectedInvestigations);
            setOtherServices(otherServices);
          }

          let advices = JSON.parse(dataArray?.emrAdvices || "[]");
          let editAdvices = [];
          if (advices.length > 0) {
            for (let adv of advices) {
              let adviceObj = {
                id: adv?.id,
                label: adv?.advice,
                value: adv?.advices,
              };
              editAdvices.push(adviceObj);
              setSelectedAdvices(editAdvices);
            }
          }

          // let otherRefferal = JSON.parse();
          // let editOtherRefferal = [];
          // if (otherRefferal.length > 0) {
          //   for (let otherReff of otherRefferal) {
          //     let otherRefferralObj = {
          //       label: otherReff?.doctorName,
          //       id: otherReff?.doctorId,
          //       value: otherReff?.doctorId,
          //     };

          //     editOtherRefferal.push(otherRefferralObj);
          //     setSelectedOtherReferral(editOtherRefferal);
          //   }
          // }

          // let otherServices = JSON.parse();
          // let editOtherServices = [];
          // if (otherServices.length > 0) {
          //   for (let otherServ of otherServices) {
          //     let otherServicesObj = {
          //       id: otherServ?.serviceId,
          //       value: otherServ?.serviceId,
          //       label: otherServ?.serviceName,
          //     };

          //     editOtherServices.push(otherServicesObj);
          //     setOtherServices(editOtherServices);
          //   }
          // }

          let medications = JSON.parse(dataArray?.emrItems || "[]");
          if (medications.length > 0) {
            for (let i = 0; i < medications.length; i++) {
              let medicationObj = {
                // id: medications[i]?.id,
                Medicine: {
                  id: medications[i]?.item_id,
                  label: medications[i]?.item_name,
                  value: medications[i]?.item_id,
                  // genericDesc: medications[i]?.genericDescription,
                  // code: "",
                  Medicine: medications[i]?.item_name,
                },
                Dosage: medications[i]?.dosage,
                Frequency: {
                  id: medications[i]?.frequency_id,
                  label: medications[i]?.frequency_name,
                  value: medications[i]?.frequency_id,
                },
                Route: {
                  Id: medications[i]?.route_id,
                  label: medications[i]?.route_name,
                  value: medications[i]?.route_id,
                },
                Duration: medications[i]?.duration,
                Quantity: medications[i]?.quantity,
                Instructions: {
                  Id: medications[i]?.instruction_id,
                  label: medications[i]?.instruction_name,
                  value: medications[i]?.instruction_id,
                },
                Generic: {
                  id: medications[i]?.generic_id,
                  label: medications[i]?.generic_name,
                  value: medications[i]?.generic_id,
                },
                Form: {
                  id: medications[i]?.form_id,
                  label: medications[i]?.form_name,
                  value: medications[i]?.form_id,
                },
                isDeleted: false,
              };

              if (medicationObj?.Medicine?.Medicine !== "") {
                let dataArray = selectedMedicines;
                dataArray.splice(i, 1, medicationObj);
                setSelectedMedicines(dataArray);
              }

              setValue(`medicine[${i}].Quantity`, medicationObj.Quantity);
              setValue(
                `medicine[${i}].Instructions`,
                medicationObj.Instructions
              );

              setValue(`medicine[${i}].Form`, medicationObj.Form);

              setValue(`medicine[${i}].Generic`, medicationObj.Generic);
            }
          }
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    }
  }, [editRow]);

  return (
    <div>
      <form
        className="grid grid-cols-6 gap-2 items-center justify-center"
        onSubmit={handleSubmit(onSubmit)}
      >
        {token?.doctorId === null && (
          <div className="col-span-2">
            <SearchDropdown
              control={control}
              name="doctor"
              placeholder="Doctor"
              label="Doctor"
              isSearchable={true}
              searchIcon={true}
              isClearable={true}
              dataArray={doctor}
              handleInputChange={getDoctorDropdownList}
            />
          </div>
        )}
        <div className="col-span-2">
          <InputField
            control={control}
            name="templateName"
            label={"Template Name"}
            error={errors?.templateName}
          />
        </div>
        <div className="col-span-2">
          <InputField
            control={control}
            name="description"
            label="Description"
          />
        </div>

        <div className="shadow-lg shadow-slate-300 col-start-1 col-span-2 rounded h-40">
          <div className=" bg-[#DCFCE7] text-md font-semibold flex justify-between px-2">
            <div
              className="whitespace-nowrap"
              //   onClick={() => {
              //     setOpenComplaints(true);
              //   }}
            >
              Complaints
            </div>
            <fieldset
              className="w-[75%] ml-2 flex gap-2 items-center"
              ref={complaintRef}
            >
              <CustomCreateable
                width={"170px"}
                control={control}
                name={"searchComplaint"}
                ref={complaintRef}
                placeholder={"Complaint"}
                dataArray={complaintsOptions}
                isSearchable={true}
                showSearch={true}
                handleInputChange={handleSearchComplaints}
              />
              {editComplaintIndex !== null && (
                <Tooltip title="Update">
                  <button
                    onClick={() => {
                      handleUpdateComplaint();
                    }}
                    className=" rounded-full bg-customBlue text-white"
                  >
                    <NavigateNextIcon />
                  </button>
                </Tooltip>
              )}
            </fieldset>
          </div>
          <div className=" h-[82%] overflow-y-scroll">
            {selectedComplaints?.length > 0
              ? selectedComplaints?.map((obj, index) => {
                  return (
                    <div
                      className={`flex gap-2 justify-between items-center my-1  px-2 border-b border-gray-200 h-[30px]
                       
                          `}
                    >
                      <div className="flex">
                        <div>
                          <Tooltip title="Edit Complaint">
                            <button
                              className="h-5 "
                              type="button"
                              onClick={() => {
                                handleEditComplaint(obj, index);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        </div>
                        <div>
                          <button
                            className="h-5 "
                            type="button"
                            onClick={() => {
                              handleDeleteComplaints(obj);
                            }}
                          >
                            <DeleteOutlineIcon
                              fontSize="small"
                              sx={{ color: "red" }}
                            />
                          </button>
                        </div>
                        <div className="w-full flex items-center whitespace-nowrap text-start justify-start text-sm">
                          {obj?.["label"]}
                        </div>
                      </div>
                      {/* <div className="flex gap-2 items-center py-[5px]">
                        <input
                          name={`duration${obj.id}`}
                          style={{ outline: "none" }}
                          disabled={obj?.isChecked === false ? true : false}
                          defaultValue={obj?.since}
                          placeholder="Since"
                          className="text-center h-6 w-[60px] border border-gray-400 rounded"
                          onChange={(e) => {
                            if (Number(e.target.value) > 0) {
                              let dataArray = [
                                ...selectedComplaints,
                                ...complaints,
                              ];
                              dataArray[index].since = e.target.value;
                              dataArray[index].duration = "D";
                              setComplaints(dataArray);
                            } else {
                              let dataArray = [
                                ...selectedComplaints,
                                ...complaints,
                              ];
                              dataArray[index].since = "";
                              dataArray[index].duration = "";
                              setComplaints(dataArray);
                            }
                          }}
                        />
                        <div
                          onClick={() => {
                            handleAddComplaintsDuration("D", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                 ${
                                   obj.duration === "D" && obj.since !== ""
                                     ? `bg-[#073763] text-white`
                                     : `border border-slate-600`
                                 } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          D
                        </div>
                        <div
                          onClick={() => {
                            handleAddComplaintsDuration("M", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                ${
                                  obj.duration === "M" && obj.since !== ""
                                    ? `bg-[#073763] text-white`
                                    : `border border-slate-600`
                                } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          M
                        </div>
                        <div
                          onClick={() => {
                            handleAddComplaintsDuration("Y", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                ${
                                  obj.duration === "Y" && obj.since !== ""
                                    ? `bg-[#073763] text-white`
                                    : `border border-slate-600`
                                } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          Y
                        </div>
                      </div> */}
                    </div>
                  );
                })
              : ""}
          </div>
        </div>

        <div className="shadow-lg col-span-2 shadow-slate-300 rounded h-40">
          <div className=" bg-[#ECFCCB] text-md font-semibold flex gap-2 px-2 cursor-pointer">
            <div
              className="w-[]"
              //   onClick={() => {
              //     setOpenDiagnosis(true);
              //   }}
            >
              Diagnosis
            </div>
            <div className="flex justify-end w-full">
              <CustomCreateable
                control={control}
                name={"searchDiagnosis"}
                dataArray={diagnoOptions}
                placeholder={"Diagnosis"}
                handleInputChange={handelSearchDiagnosis}
                width={"170px"}
                isSearchable={true}
              />
            </div>
          </div>
          <div className=" h-[82%] overflow-y-scroll">
            {/* {selectedDiagnosis?.length > 0
              ? selectedDiagnosis.map((diagno) => {
                  // if (diagno?.isChecked === true) {
                 
                  return (
                    <div className="flex gap-2 font-Poppins items-center justify-start border border-gray-200 py">
                      <div>
                        <button
                          // className="h-5 "
                          type="button"
                          onClick={() => {
                            handleDeleteDiagnosis(diagno);
                          }}
                        >
                          <DeleteOutlineIcon
                            fontSize="small"
                            sx={{ color: "red" }}
                          />
                        </button>
                      </div>
                      <div className="mt-[1px]">
                        <div className="w-[70%] font-medium truncate flex justify-start ">
                          {diagno?.label}
                        </div>

                        {diagno.since !== undefined && diagno.duration && (
                          <div>{diagno.since + " " + diagno?.duration}</div>
                        )}
                      </div>
                    </div>
                  );
                  // }
                })
              : ""} */}

            {selectedDiagnosis?.length > 0
              ? selectedDiagnosis.map((obj, index) => {
                  // if (diagno?.isChecked === true) {
                  return (
                    <div
                      className={`flex gap-2 items-center my-1  px-2 border-b border-gray-200 h-[30px]`}
                    >
                      <div>
                        <button
                          className="h-5 "
                          type="button"
                          onClick={() => {
                            handleDeleteDiagnosis(obj);
                          }}
                        >
                          <DeleteOutlineIcon
                            fontSize="small"
                            sx={{ color: "red" }}
                          />
                        </button>
                      </div>

                      <div className="truncate flex justify-start px-2 ">
                        {obj?.label}
                      </div>

                      {/* <div className="flex gap-2 items-center py-[5px]">
                        <input
                          name={`daignosis${obj.id}`}
                          style={{ outline: "none" }}
                          disabled={obj?.isChecked === false ? true : false}
                          defaultValue={obj?.since}
                          placeholder="Since"
                          className="text-center h-6 w-[60px] border border-gray-400 rounded"
                          onChange={(e) => {
                            if (Number(e.target.value) > 0) {
                              let dataArray = [
                                ...selectedDiagnosis,
                                ...diagnosis,
                              ];
                              dataArray[index].since = e.target.value;
                              dataArray[index].duration = "D";
                              setComplaints(dataArray);
                            } else {
                              let dataArray = [
                                ...selectedDiagnosis,
                                ...diagnosis,
                              ];
                              dataArray[index].since = "";
                              dataArray[index].duration = "";
                              setComplaints(dataArray);
                            }
                          }}
                        />
                        <div
                          onClick={() => {
                            handleAddDiagnosisDuration("D", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                               ${
                                                 obj.duration === "D" &&
                                                 obj.since !== ""
                                                   ? `bg-[#073763] text-white`
                                                   : `border border-slate-600`
                                               } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          D
                        </div>
                        <div
                          onClick={() => {
                            handleAddDiagnosisDuration("M", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                              ${
                                                obj.duration === "M" &&
                                                obj.since !== ""
                                                  ? `bg-[#073763] text-white`
                                                  : `border border-slate-600`
                                              } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          M
                        </div>
                        <div
                          onClick={() => {
                            handleAddDiagnosisDuration("Y", index);
                          }}
                          className={`h-5 text-md w-5 rounded-full 
                                              ${
                                                obj.duration === "Y" &&
                                                obj.since !== ""
                                                  ? `bg-[#073763] text-white`
                                                  : `border border-slate-600`
                                              } flex justify-center items-center text-md cursor-pointer pt-[1px]`}
                        >
                          Y
                        </div>
                      </div> */}
                    </div>
                  );
                  // }
                })
              : ""}
          </div>
        </div>

        <div className="shadow-lg col-span-2 shadow-slate-300 rounded h-40">
          <div className="cursor-pointer bg-[#FFE6C9] text-md font-semibold flex justify-between px-2">
            <div
            //   onClick={() => {
            //     setOpenInvestigation(true);
            //   }}
            >
              Investigations
            </div>
            <div className="w-[65%] z-50">
              <CustomCreateable
                width={"170px"}
                control={control}
                name={"searchInvestigations"}
                placeholder={"Investigations"}
                dataArray={invOptions}
                handleInputChange={handleSearchInvestigations}
                isSearchable={true}
                showSearch={true}
              />
            </div>
          </div>
          <div className="h-[82%] overflow-y-scroll">
            {selectedInvestigations?.length > 0
              ? selectedInvestigations.map((inv) => {
                  setValue(`isUrgent${inv?.id}`, inv?.isUrgent);
                  return (
                    <div className="flex gap-2 items-center border border-gray-200 py h-6">
                      {/* {inv?.isUrgent === false ? (  by Abhijeet sir */}
                      <div>
                        <button
                          className="h-5 "
                          type="button"
                          onClick={() => {
                            handleDeleteInv(inv);
                          }}
                        >
                          <DeleteOutlineIcon
                            fontSize="small"
                            sx={{ color: "red" }}
                          />
                        </button>
                      </div>
                      {/* ) : (
                            ""
                          )} */}

                      <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                        {inv?.label}
                      </div>
                    </div>
                  );
                })
              : ""}
          </div>
        </div>

        <div className="my-2 rounded col-span-6 shadow-lg shadow-slate-300">
          <div>
            <TemplateMedicinesTable
              highlightRow={false}
              tableClass="h-[270px]"
              renderInput={renderInput}
              renderActions={renderActions}
              handleAllDurations={handleAllDurations}
              editableColumns={[
                "Medicine",
                "Dosage",
                "Generic",
                "Frequency",
                "Duration",
                "Instructions",
                "Route",
                "Quantity",
                "Form",
                "isDeleted",
              ]}
              removeHeaders={["since", "Since", "", "Days", "id", "id"]}
              dataResult={selectedMedicines}
            />
          </div>
        </div>

        <div className="rounded shadow-lg col-span-2 shadow-slate-300">
          <div className="col-span-2 h-36 ">
            <div className="  h-9 flex justify-between px-2 pt-1 bg-[#F1F1F1]">
              <div className="text-md font-semibold flex gap-2">Advices</div>
              <div className="w-[65%]">
                <CustomCreateable
                  width={"170px"}
                  control={control}
                  name={"searchAdvices"}
                  placeholder={"Advices"}
                  dataArray={advicesOptions}
                  handleInputChange={() => {}}
                  isSearchable={true}
                  showSearch={true}
                />
              </div>
            </div>
            <div className="font-semibold rounded h-[75%] overflow-y-scroll">
              {selectedAdvices?.length > 0
                ? selectedAdvices.map((advice) => (
                    <div className="flex gap-2 items-center border border-gray-200 h-6">
                      <div>
                        <button
                          className="h-5 "
                          type="button"
                          onClick={() => {
                            handleDeleteAdvice(advice);
                          }}
                        >
                          <DeleteOutlineIcon
                            fontSize="small"
                            sx={{ color: "red" }}
                          />
                        </button>
                      </div>
                      <div className="w-[90%] h-5 flex justify-start px-2 font-normal whitespace-nowrap truncate">
                        {advice?.label}
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>

        {/* <div className="shadow-lg col-span-2 shadow-slate-300 rounded">
          <div className="col-span-2 h-36 ">
            <div className="flex justify-between px-2 pt-1 bg-[#F1F1F1]">
              <div className="text-sm lg:text-md font-semibold flex gap-2">
                <div
                //   onClick={() => {
                //     setOpenOtherRefferal(true);
                //   }}
                >
                  Other Referral
                </div>
              </div>

              <div className=" w-[65%]">
                <SearchDropdown
                  control={control}
                  name="referralDoctor"
                  dataArray={referralDocOptions}
                  placeholder={"Referral Doctor"}
                  isClearable={true}
                  searchIcon={true}
                  isSearchable={true}
                  handleInputChange={handleOtherReferral}
                />
              </div>
            </div>
            <div className="h-[75%] overflow-y-scroll">
              {selectedOtherReferral?.length > 0
                ? selectedOtherReferral.map((doc) => (
                    <div className="flex gap-2 items-center border border-gray-200 h-6">
                      <div>
                        <button
                          className="h-5 "
                          type="button"
                          onClick={() => {
                            handleDeleteOtherReferral(doc);
                          }}
                        >
                          <DeleteOutlineIcon
                            fontSize="small"
                            sx={{ color: "red" }}
                          />
                        </button>
                      </div>
                      <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                        {doc?.label}
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div> */}

        <div className="shadow-lg col-span-2 shadow-slate-300 rounded">
          <div className=" rounded h-36">
            <div className="flex justify-between bg-[#FFE6C9]">
              <div
                // onClick={() => {
                //   setOpenServices(true);
                // }}
                className="cursor-pointer bg-[#FFE6C9] text-md font-semibold flex justify-start px-2"
              >
                Other Services
              </div>
              <div className="w-[65%]">
                <CustomCreateable
                  width={"170px"}
                  control={control}
                  name={"searchOtherServices"}
                  placeholder={"Other Services"}
                  dataArray={servicesOptions}
                  handleInputChange={handleSearchServices}
                  isSearchable={true}
                  showSearch={true}
                />
              </div>
            </div>

            <div className="h-[75%] overflow-y-scroll">
              {otherServices?.length > 0
                ? otherServices.map((service) => {
                    return (
                      <div className="flex gap-2 items-center border border-gray-200 py h-6">
                        <div>
                          <button
                            className="h-5 "
                            type="button"
                            onClick={() => {
                              handleDeleteOtherService(service);
                            }}
                          >
                            <DeleteOutlineIcon
                              fontSize="small"
                              sx={{ color: "red" }}
                            />
                          </button>
                        </div>

                        <div className="w-[90%] h-5 flex justify-start px-2  whitespace-nowrap truncate">
                          {service?.label}
                        </div>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>

        <div className="col-span-2 gap-2 flex items-end justify-end">
          <CommonButton
            label={"Reset"}
            type={"button"}
            onClick={() => {
              reset(defaultValues);
              setSelectedComplaints([]);
              setSelectedDiagnosis([]);
              setSelectedInvestigations([]);
              setSelectedAdvices([]);
              setOtherServices([]);
            }}
            className={"border border-customRed text-customRed"}
          />

          <CommonButton
            label={editRow === null ? "Submit" : "Update"}
            type={"submit"}
            className={"text-white bg-customGreen"}
          />
        </div>
      </form>
      {openConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={openConfirmationModal}
          confirmationHandleClose={() => {
            setOpenConfirmationModal(false);
          }}
          confirmationSubmitFunc={() => {
            handleOnSubmit();
          }}
          confirmationLabel="Confirmation "
          confirmationMsg="Are You Sure ?"
          confirmationButtonMsg="Proceed"
        />
      )}
    </div>
  );
}

export default NewEmrTemplate;
